import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from '../../components/reusable/app-navigate/AppNavigate';
import { Paths } from '../../shared/paths';
import User from './user/User';
import UserCommunities from './user/userCommunities/UserCommunities';
import UserSubscribers from './user/userSubscribers/UserSubscribers';
import UserSubscriptions from './user/userSubscriptions/UserSubscriptions';
import Users from './users/Users';
import AllUsers from './users/all-users/AllUsers';
import MyRequests from './users/my-requests/MyRequests';
import MySubscribers from './users/my-subscribers/MySubscribers';
import MySubscriptions from './users/my-subscriptions/MySubscriptions';

export default function UsersRouter() {
  return (
    <Routes>
      <Route path={Paths.users.list} element={<Users />}>
        <Route index element={<AllUsers />} />
        <Route path={Paths.users.subscriptions} element={<MySubscriptions />} />
        <Route path={Paths.users.subscribers} element={<MySubscribers />} />
        <Route path={Paths.users.requests} element={<MyRequests />} />
        {/*<Route*/}
        {/*  path={'*'}*/}
        {/*  element={<Navigate to={Paths.users.toList} replace />}*/}
        {/*/>*/}
      </Route>
      <Route
        path={Paths.users.userCommunities(':userId')}
        element={<UserCommunities />}
      />
      <Route
        path={Paths.users.userSubscribers(':userId')}
        element={<UserSubscribers />}
      />
      <Route
        path={Paths.users.userSubscriptions(':userId')}
        element={<UserSubscriptions />}
      />
      <Route path={'/:userId'} element={<User />} />
      <Route
        path={'*'}
        element={<AppNavigate to={Paths.users.toList} replace />}
      />
    </Routes>
  );
}
